// helpers
import * as yup from 'yup';

// constants
import {
  DESCRIPTION_MAX_LENGTH,
  DESCRIPTION_MIN_LENGTH,
} from '../../constants/global';
import {
  NULLABLE_NUMBER_VALIDATION_RULE,
  NULLABLE_STRING_VALIDATION_RULE,
  STRING_VALIDATION_RULE,
} from '../common';

const BankAccountRequiredValidationSchema = yup.object().shape({
  purpose: STRING_VALIDATION_RULE.min(DESCRIPTION_MIN_LENGTH, {
    key: 'form:validation_messages.min_characters',
    values: {
      number: DESCRIPTION_MIN_LENGTH,
    },
  })
    .max(DESCRIPTION_MAX_LENGTH, {
      key: 'form:validation_messages.max_characters',
      values: {
        number: DESCRIPTION_MAX_LENGTH,
      },
    })
    .required('form:validation_messages.required'),

  type: yup.mixed().nullable().required('form:validation_messages.required'),

  currencyId: NULLABLE_NUMBER_VALIDATION_RULE.typeError(
    'form:validation_messages.only_numbers',
  ).required('form:validation_messages.required'),

  initialDeposit: yup
    .mixed()
    .nullable()
    .required('form:validation_messages.required'),

  initialDepositOrigin: yup
    .array()
    .min(1, 'form:validation_messages.required')
    .required('form:validation_messages.required'),

  jurisdictions: yup
    .array()
    .min(1, 'form:validation_messages.required')
    .required('form:validation_messages.required'),

  incomingWiresNumber: yup
    .mixed()
    .nullable()
    .required('form:validation_messages.required'),

  estimatedIncomingFunds: yup
    .mixed()
    .nullable()
    .required('form:validation_messages.required'),

  outgoingWiresNumber: yup
    .mixed()
    .nullable()
    .required('form:validation_messages.required'),

  estimatedOutgoingFunds: yup
    .mixed()
    .nullable()
    .required('form:validation_messages.required'),
});

const BankAccountOptionalValidationSchema = yup.object().shape({
  purpose: STRING_VALIDATION_RULE.min(DESCRIPTION_MIN_LENGTH, {
    key: 'form:validation_messages.min_characters',
    values: {
      number: DESCRIPTION_MIN_LENGTH,
    },
  }).max(DESCRIPTION_MAX_LENGTH, {
    key: 'form:validation_messages.max_characters',
    values: {
      number: DESCRIPTION_MAX_LENGTH,
    },
  }),

  type: yup.mixed().nullable(),

  currencyId: NULLABLE_NUMBER_VALIDATION_RULE.typeError(
    'form:validation_messages.only_numbers',
  ),

  initialDeposit: yup.mixed().nullable(),

  initialDepositOrigin: yup.array(),

  jurisdictions: yup.array(),

  incomingWiresNumber: yup.mixed().nullable(),

  estimatedIncomingFunds: yup.mixed().nullable(),

  outgoingWiresNumber: yup.mixed().nullable(),

  estimatedOutgoingFunds: yup.mixed().nullable(),
});

export const AccountInformationStepValidationSchema = yup.object().shape({
  submitActionType: yup.mixed().nullable(),
  isSave: yup.boolean().nullable().defined(),
  accounts: yup.array().when('isSave', {
    is: true,
    then: (schema) => schema.of(BankAccountOptionalValidationSchema),
    otherwise: (schema) => schema.of(BankAccountRequiredValidationSchema),
  }),
});
